import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { PageHeader, PageFooter, VerificationForm } from "components/organisms";
import { Modal } from "@mm/ui";
import { OfferProvider } from "features/Offer";

import { useTariffs, useHardwareRootInfo, useOffer } from "utils/fetchData";

import filterConfig from "features/Filter/config";

import RenderListingSection from "sections/RenderListingSection";

import { HardwareDetailsSection, InfoSection } from "sections/index";

import FilterSection from "features/Filter/FilterSection";
import Filter from "features/Filter";

import { findAndFilterInSections, TeaserSection } from "utils/sectionsUtlis";

import { StandardPageTemplate } from "../../components/templates";

import Sections from "../sections";

const { shownFacets } = filterConfig;

const ProductDetailPage = ({ queryParams }) => {
  // Hardware root infos
  const { data: rootInfoData } = useHardwareRootInfo();

  // Tariff details
  const { data: tariffsData } = useTariffs(queryParams, {
    // The query will not execute until the rootInfoData exists
    enabled: !!rootInfoData,
  });

  // Section data
  const getOfferId = rootInfoData?.offerId;
  const sectionData = useOffer(getOfferId, {
    // The query will not execute until the getOfferId exists
    enabled: !!getOfferId,
  });

  const [tariffs, setTariffs] = useState(null);
  const [sections, setSections] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);

  useEffect(() => {
    if (rootInfoData?.protected) {
      setModalStatus(rootInfoData.protected);
    }
  }, [rootInfoData]);

  useEffect(() => {
    if (tariffsData) {
      setTariffs(tariffsData);
    }
  }, [tariffsData]);

  useEffect(() => {
    if (sectionData.isSuccess) {
      setSections(sectionData.data.sections);
    }
  }, [sectionData]);

  if (!rootInfoData && !tariffsData) {
    return null;
  }

  const {
    hardware: { extendedVariants },
  } = rootInfoData;

  return (
    <OfferProvider
      queryParams={queryParams}
      isProductDetailInterface
      rootInfoData={rootInfoData}
      extendedVariantsData={extendedVariants}
    >
      <Filter
        variant="tariff"
        queryParams={queryParams}
        isListingPage={false}
        isProductDetailInterface
        data={tariffs}
        shownFacets={shownFacets.hardwarePDP}
      >
        <StandardPageTemplate
          header={<PageHeader itemCount={1} />}
          sections={[
            // eslint-disable-next-line react/jsx-key
            <RenderListingSection
              section={findAndFilterInSections(sections, "top")}
              position="Top"
              spaceWrapper
            />,
            // eslint-disable-next-line react/jsx-key
            <Modal
              closable={false}
              dynamicHeight
              isInitialOpen={modalStatus}
              onRequestClose={() => {
                setModalStatus(true);
              }}
            >
              <VerificationForm
                headline="Sie haben ein Produkt bei MediaMarkt gekauft. Da es sich
                hierbei um ein exklusives Angebot handelt, geben Sie
                bitte hier ihre 9-stellige MediaMarkt Rechnungsnummer ein."
                errorMessage={
                  <>
                    Ihre Authentifizierung war nicht gültig. Bitte probieren Sie
                    es erneut oder entdecken Sie weitere Angebote auf der{" "}
                    <a href="/"> Startseite</a>
                  </>
                }
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onClick={() => {
                  setModalStatus(false);
                }}
                validationRule={/^19\d{7}$/}
                buttonText="Jetzt authentifizieren"
                disclaimerText={
                  <>
                    Sie können sich nicht authentifizieren. Weiter zur{" "}
                    <a href="/"> Startseite</a>
                  </>
                }
                maxLength="9"
                label="Auftragsnummer"
              />
            </Modal>,
            // eslint-disable-next-line react/jsx-key
            <HardwareDetailsSection />,
            // eslint-disable-next-line react/jsx-key
            <RenderListingSection
              section={findAndFilterInSections(sections, "middle")}
              position="Middle"
              spaceWrapper
            />,
            // eslint-disable-next-line react/jsx-key
            <FilterSection variant="tariff" />,
            // eslint-disable-next-line react/jsx-key
            <TeaserSection
              section={findAndFilterInSections(sections, "bottom")}
            />,
            // eslint-disable-next-line react/jsx-key
            <InfoSection />,
            // eslint-disable-next-line react/jsx-key
            <Sections.RichSEOSection />,
          ]}
          footer={<PageFooter />}
        />
      </Filter>
    </OfferProvider>
  );
};

ProductDetailPage.propTypes = {
  queryParams: PropTypes.shape({}),
};

ProductDetailPage.defaultProps = {
  queryParams: null,
};

export default ProductDetailPage;
